module.exports = __webpack_public_path__ + "static/media/24-3.5ce66b40.mp3";